"use client";

import { Hero } from "@/components/layout/Hero";
import { Services } from "@/components/sections/Services";
import { About } from "@/components/sections/About";
import { Skills } from "@/components/sections/Skills";
import { Process } from "@/components/sections/Process";
import { Stats } from "@/components/sections/Stats";
import { Portfolio } from "@/components/sections/Portfolio";
import { Partners } from "@/components/sections/Partners";
import { Contact } from "@/components/sections/Contact";
import { DesignerPromo } from "@/components/sections/DesignerPromo";
import { News } from "@/components/sections/News";

export default function Home() {
  return (
    <div className="flex flex-col w-full">
      <Hero />
      <News />
      <Services />
      <About />
      <Skills />
      <Process />
      <Stats />
      <Portfolio />
      <Partners />
      <DesignerPromo />
      <Contact />
    </div>
  );
}
